import { Dialog } from "@/components/shared/dialog";
import { Card, Flex, Separator, Text, Badge, Button } from "@radix-ui/themes";
import { EnvelopeClosedIcon, FileTextIcon } from "@radix-ui/react-icons";
import { toast } from "sonner";

import { useForgetFeedback } from "../chat/api"; // simulator todo - replace
import { useWorkspace } from "@/routes/simulator/context/wrokspace"; // simulator todo - replace
import { useReleaseConversationApi } from "@/v2/entities/release-conversation/ReleaseConversation.api";

import styles from "./styles.module.scss";

export const MessageSources = ({
  isOpen,
  setOpen,
  sources,
  enableForgetIt = true,
}: {
  isOpen: boolean;
  setOpen: (value: React.SetStateAction<boolean>) => void;
  sources: any[] | null;
  enableForgetIt?: boolean;
}) => {
  const { updateReleaseConversationFeedback } = useReleaseConversationApi();

  if (!sources) {
    return null;
  }

  return (
    <Dialog open={isOpen} onOpenChange={(v) => setOpen(v)}>
      <Dialog.Content size={"large"}>
        <Dialog.Close className={styles.Close} />
        <Dialog.Title>List of sources reviewed before answering</Dialog.Title>
        <div className={styles.SourceDialogList}>
          {sources &&
            Array.isArray(sources) &&
            sources?.map((s) => {
              if (!s) {
                return null;
              }
              const sMetadata = s.metadata.metadata?.$dist
                ? s.metadata.metadata
                : s.metadata;

              const isTicket =
                !sMetadata?.indexName?.includes("kb") &&
                !sMetadata?.indexName?.includes("wiki");
              const ticketIdMatch = s.id?.match(/\d+/);
              const ticketId =
                isTicket && ticketIdMatch ? ticketIdMatch[0] : "";

              return (
                <div>
                  <Card>
                    <div className={styles.SourceTopbar}>
                      <Flex gap="2" align="center">
                        {sMetadata?.indexName?.includes("kb") ||
                        sMetadata?.indexName?.includes("wiki") ? (
                          <FileTextIcon />
                        ) : (
                          <EnvelopeClosedIcon />
                        )}
                        <Text as="label" size={"5"}>
                          {isTicket
                            ? sMetadata?.isGenerated
                              ? "Training Session"
                              : `Ticket #${ticketId}`
                            : sMetadata?.title}
                        </Text>
                        {sMetadata?.indexName?.includes("wiki") && (
                          <Badge color="red">Internal</Badge>
                        )}
                        {sMetadata?.positiveFeedback == 1 ? (
                          <Badge color="green">Good Feedback</Badge>
                        ) : (
                          <Badge color="blue">Imported</Badge>
                        )}
                      </Flex>
                      {enableForgetIt && sMetadata?.positiveFeedback == 1 && (
                        <Button
                          variant="outline"
                          color="gray"
                          size="1"
                          onClick={async () => {
                            await updateReleaseConversationFeedback(
                              s.id.toString().split("-")[0],
                              {
                                feedback: "FORGOTTEN",
                                feedbackComment: "Forgotten by user",
                              }
                            );
                            toast("Feedback forgotten successfully");
                          }}
                        >
                          Forget it
                        </Button>
                      )}
                    </div>
                    <Separator size={"4"} />
                    <Text as="label" size={"2"}>
                      {isTicket ? sMetadata?.answer : sMetadata?.text}
                    </Text>
                  </Card>
                </div>
              );
            })}
        </div>
      </Dialog.Content>
    </Dialog>
  );
};
